import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button, Card, Empty, Table, Tag } from "antd";
import api from "Common/Client/Interceptor";
import useServerPagination from "Common/hooks/useServerPagination";
const Trainings = () => {
  const token = localStorage.getItem("token");
  const { id } = useParams();
  const [groupDetail, setGroupDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  // Members moved out of the parent detail into a separate paginated endpoint.
  const {
    items: members,
    loading: membersLoading,
    paginationProps,
  } = useServerPagination(({ pageNumber, pageSize, orderByLatest }) =>
    api
      .get("/TrainingGroup/Members/List", {
        params: { groupId: id, pageNumber, pageSize, orderByLatest },
      })
      .then((r) => r.data)
  );
  useEffect(() => {
    const fetchGroupDetail = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/TrainingGroup/Detail?GroupId=${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setGroupDetail(response.data);
      } catch (error) {
        console.error("Error fetching group details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchGroupDetail();
  }, [id]);
  const columns = [
    {
      title: groupDetail?.groupType === 2 ? "Group Member ID" : "Participant ID",
      dataIndex: "learnerId",
      key: "learnerId",
    },
    {
      title: groupDetail?.groupType === 2 ? "Group Member Name" : "Participant Name",
      dataIndex: "learnerName",
      key: "learnerName",
    },
    {
      title: "Business Group Name",
      dataIndex: "businessGroupName",
      render: (text) => (text ? text : "N/A"),
    },
  ];
  return (
    <Card
      title="Assigned Group Detail"
      className="card-professional"
      loading={loading}
      extra={
        <Button type="default" onClick={() => navigate("/assigned-groups")}>
          Back
        </Button>
      }
    >
      <Button className="mb-3" type="primary" onClick={() => navigate(`/view-training/${id}`)}>
        View Training
      </Button>
      {groupDetail ? (
        <>
          <p>
            <strong>Group Name:</strong> {groupDetail.groupName}
          </p>
          <p>
            <strong>Mentor Name:</strong> {groupDetail.mentorName}
          </p>
          <p>
            <strong>Created On:</strong> {new Date(groupDetail.createdOn).toLocaleString()}
          </p>
          <Tag style={{ backgroundColor: "orange", color: "white", marginBottom: 10 }}>
            {groupDetail?.isRetryTraining ? "Repeated" : ""}
          </Tag>
          <h4>{groupDetail?.groupType === 2 ? "Group Members" : "Participant"}</h4>
          <Table
            dataSource={members}
            loading={membersLoading}
            columns={columns}
            rowKey="id"
            pagination={paginationProps}
            scroll={{ x: "max-content" }}
          />
        </>
      ) : (
        <Empty description="No group details found." />
      )}
    </Card>
  );
};
export default Trainings;
